import { RegistereRibbonButton, SimpleDialog, useAppInfo, useModelDrivenApp, useRibbon } from "@eavfw/apps";
import { CompoundButton, Input, Field } from "@fluentui/react-components";
import { useBoolean } from "@fluentui/react-hooks";
import { PlugDisconnected24Regular } from "@fluentui/react-icons";
import { useCallback, useState } from "react";

RegistereRibbonButton("CUSTOM_FETCH_MATCHES", ({ key, ...props }) => {
    const { registerButton } = useRibbon();
    const { currentEntityName, currentRecordId } = useAppInfo();

    const [password, setPassword] = useState<string>();
    const app = useModelDrivenApp();
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);

    const connect = useCallback(() => {

        let rsp = fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/entities/${app.getEntity(currentEntityName).collectionSchemaName}/records/${currentRecordId}/workflows/FetchMatchesWorkFlow/runs`, {
            method: "POST",
            body: JSON.stringify({
                
            }),
            credentials: "include"
        });
    }, [password]);

    registerButton({
        key: key,
        text: props.text ?? "Fetch Matches",
        iconProps: props.iconProps ?? { iconName: 'PasswordField' },
        title: props.title ?? props.text ?? "Reset Password",
        disabled: false,
        onClick: () => {
            toggleHideDialog();

        }
        //workflow: props.workflow
        // onClick: onClick
    });


    return <SimpleDialog hideDialog={hideDialog} toggleHideDialog={toggleHideDialog}>
        <Field hint="The new password" label="The new password"  ><Input onChange={(ev, v) => setPassword(v.value)} /></Field>
        <CompoundButton
            icon={<PlugDisconnected24Regular />}
            secondaryContent="The password will be ashed in the database and not stored" onClick={connect}
        >
            Fetch
        </CompoundButton>

    </SimpleDialog>

});




RegistereRibbonButton("RUN_REMOTE_WORKFLOW", ({ key, ...props }) => {
    const { registerButton, events } = useRibbon();
    const { currentEntityName, currentRecordId } = useAppInfo();


    const app = useModelDrivenApp();

    registerButton({
        key: key,
        text: props.text ?? "Run Workflow",
        iconProps: props.iconProps ?? { iconName: 'Send' },
        title: props.title ?? props.text ?? "Run Workflow",
        disabled: false,
        onClick: () => {

            //@ts-ignore
            let rsp = fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/entities/${app.getEntity(currentEntityName).collectionSchemaName}/records/${currentRecordId}/workflows/${props.workflowName}/runs`, {
                method: "POST",
                body: JSON.stringify({
                    trigger: {

                    },
                    payload: {
                        "enrichManifest": true,
                        "runSecurityModelInitializationScript": true
                    }
                }),
                credentials: "include"
            });
        }
        //workflow: props.workflow
        // onClick: onClick
    });

});